import React from "react"

export function PageColumns({ children, align, media, modifiers }) {
  return (
    <div
      className={`page-columns ${align ? `page-columns--align-${align}` : ""}
      ${media ? "page-columns--media" : ""}
      ${modifiers ? modifiers : ""}`}
    >
      {children}
    </div>
  )
}

export function Column({ children, location, classes }) {
  return (
    <div
      className={`
        page-columns__column
        page-columns__column--${location || "center"}
        ${classes ? classes : ""}
      `}
    >
      {children}
    </div>
  )
}
